/* loaded by smart-asset */
export default require("./assets/success.ogg")